import { render, staticRenderFns } from "./BCDId.vue?vue&type=template&id=4de47b28"
import script from "./BCDId.vue?vue&type=script&lang=js"
export * from "./BCDId.vue?vue&type=script&lang=js"
import style0 from "./BCDId.vue?vue&type=style&index=0&id=4de47b28&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports